import { render, staticRenderFns } from "./PdpPopup.vue?vue&type=template&id=f36bcaf0&scoped=true&"
import script from "./PdpPopup.vue?vue&type=script&lang=js&"
export * from "./PdpPopup.vue?vue&type=script&lang=js&"
import style0 from "./PdpPopup.vue?vue&type=style&index=0&id=f36bcaf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36bcaf0",
  null
  
)

export default component.exports